import AppEvents from 'Shared/app-events';

import SalesInfoModel from './salesInfoModel';
import ProductApi from 'Api/product-api';
import BookmarkApi from 'Api/bookmark-api';
import CompareApi from 'Api/compare-api';
import ContactApi from 'Api/contact-api';
import CartApi from 'Api/cart-api';

class VariantItemBase {
    constructor(product) {
        this.product = product;
    }
}

export class VariantItemModel extends VariantItemBase {
    constructor(data, productId) {
        super(productId);

        this.productId = productId;

        ko.mapping.fromJS(data, this.mapping, this);
    }

    mapping = {
        SalesInfo: {
            create: options => new SalesInfoModel(options.data)
        }
    }

    loaded = ko.observable(true);

    hasBrand = ko.pureComputed(() => typeof this.Brand != 'undefined' && ko.unwrap(this.Brand));

    quantity = ko.observable();

    url = ko.pureComputed(() => this.Url());

    attrValue = attrId => this.Attributes().find(x => x.AttributeId() == attrId)?.Value ?? "-";

    quickview = (item, e) => {
        AppEvents.emit(ProductApi.Events.SHOW_VARIANT, { el: e.currentTarget, variantId: item.Id() });
    }

    bookmark = (item, e) => {
        AppEvents.emit(BookmarkApi.Events.ADD, { element: e.currentTarget, variantId: item.Id() });
    }

    compare = (item, e) => {
        AppEvents.emit(CompareApi.Events.ADD, { element: e.currentTarget, variantId: item.Id() });
    }

    request = (item, e) => {
        AppEvents.emit(ContactApi.Events.PRODUCT_REQUEST, { element: e.currentTarget, variantId: item.Id() });
    }

    cart = (item, e) => {
        AppEvents.emit(CartApi.Events.ADD, item.SalesInfo);
    }
}

export class LazyVariantItemModel extends VariantItemModel {
    constructor(data, productId) {
        super(data, productId);

        //const variant = ProductApi.cachedVariant(this.product.Id(), data.Id);
        //if (variant != undefined) {
        //    ko.mapping.fromJS(variant, this.mapping, this);
        //    this.loaded(true);
        //} else {
        //    ko.mapping.fromJS(data, {}, this);
        //}
    }

    loaded = ko.observable(false);

    load = async () => {
        if (!this.loaded()) {
            const result = await ProductApi.variant(this.productId, this.Id());

            ko.mapping.fromJS(result,  this);
            this.loaded(true);
        }
    }
}